module.exports = "<ng-template #content let-modal>\n\t<h1>{{id}}</h1>\n</ng-template>\n"